export default "__VITE_ASSET__Dhs6po8r__"